export default "__VITE_ASSET__SjbHy6jl__"